export default {
   AccountApi: '/api/AccountApi',
   ActivityApi: '/api/Activity',
   AddressFinderApi: '/api/AddressFinderApi',
   AppApi: '/api/App',
   ApprovalOfferApi: '/api/ApprovalOfferApi',
   ApprovalOfferOdataApi: '/odata/ApprovalOffer',
   ApprovalOrderApi: '/api/ApprovalOrderApi',
   ApprovalOrderResponseApi: '/api/ApprovalOrderResponseApi',
   AssemblyApi: '/api/Assembly',
   AuthenticationTestApi: '/api/AuthenticationTestApi',
   AuthorApi: '/api/Author',
   BannerAdApi: '/api/BannerAdApi',
   BannerAdOdataApi: '/odata/BannerAd',
   CampaignApi: '/api/CampaignApi',
   CampaignOdataApi: '/odata/Campaign',
   StoreCartApi: '/api/store/Cart',
   CatalogueApi: '/api/Catalogue',
   CategoryApiApi: '/api/CategoryApi',
   CategoryApi: '/api/Category',
   CategoryWithMetadataOdataApi: '/odata/CategoryWithMetadata',
   StoreCheckoutApi: '/api/store/Checkout',
   ClassRoomApi: '/api/ClassRoomApi',
   ClassRoomOdataApi: '/odata/ClassRoom',
   ContactUsApi: '/api/ContactUs',
   ContentSearchApi: '/api/ContentSearchApi',
   CountryApi: '/api/CountryApi',
   CountryOdataApi: '/odata/Country',
   CountrySchoolTermApi: '/api/CountrySchoolTermApi',
   CurrencyApi: '/api/Currency',
   CurriculumApi: '/api/CurriculumApi',
   CurriculumCacheApi: '/api/CurriculumCacheApi',
   CurriculumOdataApi: '/odata/Curriculum',
   CurriculumCoverageApi: '/api/CurriculumCoverageApi',
   CurriculumDataEditorApi: '/api/CurriculumDataEditorApi',
   CurriculumIconApi: '/api/CurriculumIconApi',
   CurriculumSectionApi: '/api/CurriculumSectionApi',
   CurriculumSectionOdataApi: '/odata/CurriculumSection',
   CurriculumSectionDataApi: '/api/CurriculumSectionDataApi',
   CurriculumSectionDataOdataApi: '/odata/CurriculumSectionData',
   CurriculumSectionItemApi: '/api/CurriculumSectionItemApi',
   CurriculumSectionItemOdataApi: '/odata/CurriculumSectionItem',
   CurriculumSettingsApi: '/api/CurriculumSettingsApi',
   DailyPlannerApi: '/api/DailyPlannerApi',
   DashboardApi: '/api/Dashboard',
   EmailApi: '/api/Email',
   FileBoxApi: '/api/FileBox',
   FileBoxItemApi: '/api/FileBoxItem',
   FileBoxItemHiddenApi: '/api/FileBoxItemHidden',
   FileBoxItemStarApi: '/api/FileBoxItemStar',
   FileProductApi: '/api/FileProduct',
   FileResourceApi: '/api/FileResource',
   FilterApi: '/api/FilterApi',
   FolderApi: '/api/Folder',
   FreebieApi: '/api/Freebie',
   FreeContentOfferApi: '/api/FreeContentOfferApi',
   FreeContentOfferOdataApi: '/odata/FreeContentOffer',
   FreeLessonApi: '/api/FreeLesson',
   FreshdeskApi: '/api/FreshdeskApi',
   GeolocationApi: '/api/GeolocationApi',
   HealthCheckApi: '/api/HealthCheck',
   ImageApi: '/api/ImageApi',
   InquiryProcessApi: '/api/InquiryProcessApi',
   InquiryProcessOdataApi: '/odata/InquiryProcess',
   InquiryStageApi: '/api/InquiryStageApi',
   InquiryStageOdataApi: '/odata/InquiryStage',
   InterestApi: '/api/InterestApi',
   InvoiceOrderResponseApi: '/api/InvoiceOrderResponseApi',
   LearningAreaApi: '/api/LearningArea',
   LessonFileBoxApi: '/api/LessonFileBox',
   LessonNoteApi: '/api/LessonNoteApi',
   LongTermPlanApi: '/api/LongTermPlanApi',
   LongTermPlanBlockApi: '/api/LongTermPlanBlockApi',
   LongTermPlanBlockOdataApi: '/odata/LongTermPlanBlock',
   LongTermPlanOdataApi: '/odata/LongTermPlan',
   MarketApi: '/api/MarketApi',
   MediaApi: '/api/Media',
   OrderHeaderApi: '/api/OrderHeaderApi',
   OrderHeaderOdataApi: '/odata/OrderHeader',
   StorePageMetadataApi: '/api/store/PageMetadata',
   PartyApi: '/api/PartyApi',
   PartyCalendarSettingsApi: '/api/PartyCalendarSettings',
   PartyCreditCardApi: '/api/PartyCreditCard',
   PartyDisplaySettingsApi: '/api/PartyDisplaySettings',
   PartyGeneralSettingsApi: '/api/PartyGeneralSettings',
   PartyHistoryApi: '/api/PartyHistoryApi',
   PartyIdentityUserApi: '/api/PartyIdentityUserApi',
   PartyIdentityUserOdataApi: '/odata/PartyIdentityUser',
   PartyInterestsApi: '/api/PartyInterests',
   PartySchoolTeacherOptionsApi: '/api/PartySchoolTeacherOptionsApi',
   PartyStreetAddressApi: '/api/PartyStreetAddress',
   PartySubscriptionApi: '/api/PartySubscriptionApi',
   PaymentApi: '/api/PaymentApi',
   StorePaymentApi: '/api/store/Payment',
   PlanApi: '/api/PlanApi',
   PlanCalendarNoteApi: '/api/PlanCalendarNoteApi',
   PlanCommentApi: '/api/PlanCommentApi',
   PlanOdataApi: '/odata/Plan',
   PlanCopyApi: '/api/PlanCopyApi',
   PlanCurriculumSectionApi: '/api/PlanCurriculumSectionApi',
   PlanDataUpdateApi: '/api/PlanDataUpdateApi',
   PlanDisabledDayApi: '/api/PlanDisabledDayApi',
   PlanLessonApi: '/api/PlanLessonApi',
   PlanLessonDayByDayApi: '/api/PlanLessonDayByDayApi',
   PlanLessonSchoolTermsApi: '/api/PlanLessonSchoolTermsApi',
   PlanLessonSequentialApi: '/api/PlanLessonSequentialApi',
   PlanLessonWeekApi: '/api/PlanLessonWeekApi',
   PlanningCategoryApi: '/api/PlanningCategoryApi',
   PlanningCategoryOdataApi: '/odata/PlanningCategory',
   PlanningCategoryGetterApi: '/api/PlanningCategoryGetterApi',
   PlanningCategoryNodeApi: '/api/PlanningCategoryNodeApi',
   PlanningCategoryWithDataApi: '/api/PlanningCategoryWithDataApi',
   PlanningChatApi: '/api/PlanningChatApi',
   PlanSchoolStudentGroupsByTypeApi: '/api/PlanSchoolStudentGroupsByTypeApi',
   PlanSchoolTeacherGroupApi: '/api/PlanSchoolTeacherGroupApi',
   PlansApi: '/api/Plans',
   PlanZeroDayApi: '/api/PlanZeroDayApi',
   ProductContentApi: '/api/ProductContent',
   ProductApi: '/api/Product',
   ProductDetailsApi: '/api/ProductDetailsApi',
   ProductLibraryApi: '/api/ProductLibrary',
   ProductPreviewApi: '/api/ProductPreview',
   ProductSearchApi: '/api/ProductSearchApi',
   PromoCodeApi: '/api/PromoCodeApi',
   PromoCodeOdataApi: '/odata/PromoCode',
   PromotionApi: '/api/PromotionApi',
   PromotionCardApi: '/api/PromotionCardApi',
   PromotionCardOdataApi: '/odata/PromotionCard',
   PromotionResponseApi: '/api/PromotionResponse',
   PublicHolidayApi: '/api/PublicHolidayApi',
   PublicHolidayOdataApi: '/odata/PublicHoliday',
   PurchasedProductApi: '/api/PurchasedProduct',
   RateLimitApi: '/api/RateLimitApi',
   ReleaseNoteApi: '/api/ReleaseNoteApi',
   ReleaseNoteOdataApi: '/odata/ReleaseNote',
   ScheduleApi: '/api/Schedule',
   SchoolAccessRequestApi: '/api/SchoolAccessRequestApi',
   SchoolAccessRequestOdataApi: '/odata/SchoolAccessRequest',
   SchoolAddressApi: '/api/SchoolAddress',
   SchoolApi: '/api/SchoolApi',
   SchoolOdataApi: '/odata/School',
   SchoolCurriculumApi: '/api/SchoolCurriculumApi',
   SchoolPlannerSettingsApi: '/api/SchoolPlannerSettingsApi',
   SchoolPlannerSettingsOdataApi: '/odata/SchoolPlannerSettings',
   SchoolStudentApi: '/api/SchoolStudentApi',
   SchoolStudentOdataApi: '/odata/SchoolStudent',
   SchoolStudentEthnicityOdataApi: '/odata/SchoolStudentEthnicity',
   SchoolStudentGroupApi: '/api/SchoolStudentGroupApi',
   SchoolStudentGroupOdataApi: '/odata/SchoolStudentGroup',
   SchoolStudentGroupMembershipApi: '/api/SchoolStudentGroupMembershipApi',
   SchoolStudentGroupTypeApi: '/api/SchoolStudentGroupTypeApi',
   SchoolStudentGroupTypeOdataApi: '/odata/SchoolStudentGroupType',
   SchoolStudentTargetTypeApi: '/api/SchoolStudentTargetTypeApi',
   SchoolStudentTargetTypeOdataApi: '/odata/SchoolStudentTargetType',
   SchoolSubscriptionApi: '/api/SchoolSubscriptionApi',
   SchoolTeacherApi: '/api/SchoolTeacherApi',
   SchoolTeacherOdataApi: '/odata/SchoolTeacher',
   SchoolTeacherGroupApi: '/api/SchoolTeacherGroupApi',
   SchoolTeacherGroupOdataApi: '/odata/SchoolTeacherGroup',
   SchoolTeacherGroupMembershipApi: '/api/SchoolTeacherGroupMembershipApi',
   SchoolTermApi: '/api/SchoolTermApi',
   SectionApi: '/api/SectionApi',
   SectionOdataApi: '/odata/Section',
   SeriesApi: '/api/Series',
   SignUpApi: '/api/SignUp',
   SiteCacheApi: '/api/SiteCacheApi',
   SiteSettingApi: '/api/SiteSettingApi',
   SiteSettingOdataApi: '/odata/SiteSetting',
   StandingOrderApi: '/api/StandingOrder',
   StayUpdatedApi: '/api/StayUpdated',
   StoreCreditApi: '/api/StoreCreditApi',
   StoreCreditOdataApi: '/odata/StoreCredit',
   StoreStoreProductApi: '/api/store/StoreProduct',
   StoreSessionApi: '/api/StoreSessionApi',
   SubscriptionApi: '/api/SubscriptionApi',
   SubscriptionOdataApi: '/odata/Subscription',
   SubscriptionLevelApi: '/api/SubscriptionLevel',
   SubscriptionPurchaseApi: '/api/SubscriptionPurchaseApi',
   TaskApi: '/api/Task',
   TaskItemApi: '/api/TaskItem',
   TimeTableApi: '/api/TimeTableApi',
   TimeTableOdataApi: '/odata/TimeTable',
   TimeTableEventApi: '/api/TimeTableEventApi',
   TimeTableEventTypeApi: '/api/TimeTableEventTypeApi',
   TimeTableEventTypeOdataApi: '/odata/TimeTableEventType',
   TimeTableFileBoxApi: '/api/TimeTableFileBox',
   TimeTableSeriesApi: '/api/TimeTableSeriesApi',
   TimeTableSeriesOdataApi: '/odata/TimeTableSeries',
   TokenTestingApi: '/api/TokenTestingApi',
   TranslationHelperApi: '/api/TranslationHelperApi',
   TrialSignupApi: '/api/TrialSignup',
   UnitPlannerApi: '/api/UnitPlannerApi',
   UploadApi: '/api/UploadApi',
   UrlConfigurationApi: '/api/UrlConfigurationApi',
   UserDataEditApi: '/api/UserDataEditApi',
   UserProfileApi: '/api/UserProfileApi',
   UserRoleApi: '/api/UserRole',
   UserSchoolApi: '/api/UserSchool',
   UserSessionApi: '/api/UserSession',
   StoreWishlistApi: '/api/store/Wishlist',
}
